export { default } from './AssetsGroups';
